import PropTypes from "prop-types";
import React from "react";
import { LabelWithIcon } from "./LabelWithIcon";

export const SectionHeader = ({ title, tooltip }) => (
  <tr>
    <th
      colSpan={2}
      className="text-uppercase font-weight-bold pt-3 pinned-section-label"
    >
      <LabelWithIcon label={title} tooltip={tooltip} />
    </th>
  </tr>
);

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default SectionHeader;
